import React from "react";
import { SEO, MainLayout, MessageMain } from "../../../components";
const MessagePage = () => {
  return (
    <>
      <SEO title="message" />
      <MainLayout>
        <MessageMain />
      </MainLayout>
    </>
  );
};

export default MessagePage;
